import { Button } from './Button';

/**
 * Empty list / empty panel placeholder.
 */
export function EmptyState({
  title = 'Nothing here yet',
  description,
  actionLabel,
  onAction,
  className = '',
  children,
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-10 px-4 gap-2 ${className}`}
    >
      <p className="text-sm font-medium text-text-muted">{title}</p>
      {description && (
        <p className="text-xs text-text-secondary max-w-sm">{description}</p>
      )}
      {children}
      {actionLabel && onAction && (
        <Button
          variant="secondary"
          className="mt-3"
          onClick={onAction}
          type="button"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
